import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { isLttry } from '../../../utils/template';

type DrawDateCounterProps = {
    nextDrawDate: string;
    drawLoop?: number;
    nextNextDrawDate?: string;
};
function DrawDateCounter({ nextDrawDate, drawLoop = 0, nextNextDrawDate = null }: DrawDateCounterProps) {
    const { t } = useTranslation();
    const [difference, setDifference] = useState(moment.duration(moment(nextDrawDate).diff(moment())));
    const [nextDraw, setNextDraw] = useState(nextDrawDate);
    const [counterRunning, setCounterRunning] = useState(true);

    useEffect(() => {
        const interval = setInterval(() => {
            const diff = moment.duration(moment(nextDraw).diff(moment()));
            setDifference(diff);

            if (diff.milliseconds() < 0) {
                clearInterval(interval);

                if (drawLoop > 0) {
                    setNextDraw(moment().add(drawLoop, 'seconds').toISOString());
                } else if (nextNextDrawDate != null) {
                    setNextDraw(nextNextDrawDate);
                } else {
                    setCounterRunning(false);
                }
            }
        }, 500);
        return () => {
            clearInterval(interval);
        };
    }, [nextDraw]);

    return !counterRunning && difference.milliseconds() < 0 ? (
        <>{t('pending')}</>
    ) : (
        <>
            {difference.days() > 0 && (
                <>
                    <span className="counter-days">{difference.days()}</span>
                    <span className="counter-days-units">
                        {difference.days() === 1 ? t('counter.day') : t('counter.days')}
                    </span>
                    {isLttry() && <span className="counter-and">{t('counter.and')}</span>}
                </>
            )}

            {(difference.hours() > 0 || (difference.hours() === 0 && difference.days() > 0 && isLttry())) && (
                <>
                    <span className="counter-hours">{difference.hours()}</span>
                    <span className="counter-hours-units">
                        {difference.hours() === 1 ? t('counter.hour') : t('counter.hours')}
                    </span>
                    {difference.days() <= 0 && isLttry() && <span className="counter-and">{t('counter.and')}</span>}
                </>
            )}

            {difference.days() <= 0 && (
                <>
                    <span className="counter-minutes">{difference.minutes()}</span>
                    <span className="counter-minutes-units">
                        {isLttry() ? t('counter.min') : (difference.minutes() === 1 ? t('counter.minute') : t('counter.minutes'))}
                    </span>

                    {difference.hours() <= 0 && (
                        <>
                            {isLttry() && <span className="counter-and">{t('counter.and')}</span>}
                            <span className="counter-seconds">{difference.seconds()}</span>
                            <span className="counter-seconds-units">
                                {isLttry() ? t('counter.sec') : (difference.seconds() === 1 ? t('counter.second') : t('counter.seconds'))}
                            </span>
                        </>
                    )}
                </>
            )}
        </>
    );
}

export default DrawDateCounter;
